import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { withFormik, FormikProps } from 'formik';
import { Grid, Box } from '@material-ui/core';
import { translate } from 'helpers/intl';
import messages from 'containers/SignupPages/AuthBySms/messages';
import ActionsButtons from 'containers/SignupPages/ActionsButtons';
import CodeInput from 'components/CodeInput';
import { LongBody } from 'components/Typography';
import { StyledButton } from 'containers/SignupPages/AuthBySms/styles';
import GATracking, { EVENT_ACTION, EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const InnerForm = (props: FormProps & FormikProps<FormValues>) => {
  const {
    values,
    errors,
    handleSubmit,
    isLoading,
    onClickPrevious,
    setFieldValue,
    proceedDifferently,
  } = props;

  const handlePinChange = (value: string) => {
    setFieldValue('pin', value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box mb={3} paddingX={[4, 8, 12]}>
        <Grid container justify="center">
          <Grid xs={12} style={{ textAlign: 'center' }} item dir="ltr">
            <CodeInput
              name="pin"
              handleChange={handlePinChange}
              value={values.pin}
              isValid={!errors.pin}
              fields={4}
              width="56px"
            />
          </Grid>
          <Grid item xs={4}>
            {errors.pin && (
              <GaLoadHOC
                category={EVENT_CATEGORIES.AUTH_BY_SMS}
                label="Chargement du bloc d'erreur"
                action={EVENT_ACTION.ERROR}
              >
                <Box marginTop={1} marginLeft={3} marginBottom={4}>
                  <LongBody color="#f5523c">
                    {translate({ ...messages.validationErrorMessage }, props)}
                  </LongBody>
                </Box>
              </GaLoadHOC>
            )}
          </Grid>
          {/* <Grid item xs={matches ? 12 : 4} style={{ textAlign: 'right' }}>
            <Box marginRight={5} marginTop={1} marginBottom={4}>
              <GaClickHOC
                category={EVENT_CATEGORIES.AUTH_BY_SMS}
                label="Je n'ai pas reçu le code"
              >
                <LongBody weight="500">
                  {translate({ ...messages.notYetReceived }, props)}
                </LongBody>
              </GaClickHOC>
            </Box>
          </Grid> */}
          <GaClickHOC
            category={EVENT_CATEGORIES.AUTH_BY_SMS}
            label="Procéder autrement"
          >
            <StyledButton
              style={{ marginTop: '22px' }}
              variant="outlined"
              onClick={proceedDifferently}
            >
              {translate({ ...messages.proceedDifferently }, props)}{' '}
            </StyledButton>
          </GaClickHOC>
        </Grid>
      </Box>
      <ActionsButtons onClickPrevious={onClickPrevious} isLoading={isLoading} />
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  isLoading: boolean;
  onClickPrevious: Function;
  proceedDifferently: Function;
  onSubmitStep: Function;
}

interface FormValues {
  pin: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      pin: '',
    };
  },

  handleSubmit: (values, { props, setFieldError }) => {
    GATracking.event(
      EVENT_CATEGORIES.AUTH_BY_SMS,
      EVENT_ACTION.CLICK,
      'valider',
    );

    if (values.pin.length !== 4) {
      return setFieldError('pin', 'error');
    }

    return props.onSubmitStep(values);
  },
})(InnerForm);

export default injectIntl(Form);
